import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-pocomments-lookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './pocomments-lookup.component.html',
  styleUrl: './pocomments-lookup.component.scss'
})
export class POCommentsLookupComponent implements OnInit {

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  comment: string = "";
  Edit : boolean = false;

  ngOnInit(): void {
    const lineItemData = this.config.data;
    this.Edit = this.config.data.Edit;
    this.comment = lineItemData.Comment;
  }

  saveComment() {
    if(this.comment == ""){
      this.comment = " ";
    }
    this.ref.close(this.comment);
  }

}
